import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FileIcon from 'components/molecules/FileIcon';
import Heading from 'components/atoms/Heading';
import { folderTypes, audioTypes, documentTypes, imageTypes, videoTypes } from 'helpers/constants';
import { fadeInDown } from 'helpers/animations';

const StyledHeading = styled(Heading)`
  font-size: 24pt;
  color: ${({ theme }) => theme.textSecondary};
  animation: ${fadeInDown} ${({ theme }) => theme.fadeInDown};
`;

function Folder({ match, files, handleShowDetails, query, isDetailsVisible }) {
  const [localFiles, setLocalFiles] = useState([]);

  useEffect(() => {
    const arr = [];
    let typesArr;

    switch (match.params.folder) {
      case folderTypes.latest:
        typesArr = 'latest';
        break;

      case folderTypes.all:
        typesArr = 'all';
        break;

      case folderTypes.documents:
        typesArr = documentTypes;
        break;

      case folderTypes.audio:
        typesArr = audioTypes;
        break;

      case folderTypes.images:
        typesArr = imageTypes;
        break;

      case folderTypes.videos:
        typesArr = videoTypes;
        break;

      default:
        typesArr = 'custom';
        break;
    }

    if (typesArr === 'all') {
      files.forEach((file) => arr.push(file));
    } else if (typesArr === 'latest') {
      files.forEach((file) => {
        if (file.uploaded > new Date().getTime() - 24 * 60 * 60 * 1000) {
          arr.push(file);
        }
      });
    } else if (typesArr === 'custom') {
      files.forEach((file) => {
        if (file.folder === match.params.folder) {
          arr.push(file);
        }
      });
    } else {
      files.forEach((file) => {
        if (typesArr.includes(file.type)) {
          arr.push(file);
        }
      });
    }

    setLocalFiles(arr);
  }, [files, match]);

  useEffect(() => {
    setLocalFiles((prevState) =>
      prevState.filter((obj) => obj.name.toLowerCase().includes(query.toLowerCase())),
    );
  }, [query, isDetailsVisible]);

  return (
    <>
      {localFiles.length ? (
        localFiles
          .sort((a, b) => a.name.localeCompare(b.name))
          .map(({ folder, name, type, key }, i) => (
            <FileIcon
              name={name}
              type={type}
              key={key}
              id={key}
              folder={folder}
              handleShowDetails={handleShowDetails}
              delay={i * 0.02}
            />
          ))
      ) : (
        <StyledHeading>Nic tu nie ma</StyledHeading>
      )}
    </>
  );
}

Folder.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      folder: PropTypes.string,
    }),
  }),
  handleShowDetails: PropTypes.func.isRequired,
  files: PropTypes.arrayOf(
    PropTypes.shape({
      folder: PropTypes.string,
      key: PropTypes.string,
      lastModified: PropTypes.number,
      uploaded: PropTypes.number,
      name: PropTypes.string,
      size: PropTypes.number,
      type: PropTypes.string,
    }),
  ),
  query: PropTypes.string,
  isDetailsVisible: PropTypes.bool,
};

Folder.defaultProps = {
  files: [],
  query: '',
  match: {
    params: {
      folder: 'all',
    },
  },
  isDetailsVisible: false,
};

export default Folder;
